import { render, staticRenderFns } from "./EquityChangeDetailsUs.vue?vue&type=template&id=2fb03e82"
import script from "./EquityChangeDetailsUs.vue?vue&type=script&lang=js"
export * from "./EquityChangeDetailsUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports